import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ServiceProvider } from 'src/app/models/service_provider.model';
import { ServiceProviderService } from 'src/app/services/service_provider_service.service';
import { TokenStorageService } from 'src/app/services/token_storage.service';
import { UntypedFormControl, UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PaginationHeaderData } from 'src/app/models/pagination-header-data.model';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatNoDataRow } from '@angular/material/table';
import { MatProgressBar } from '@angular/material/progress-bar';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'provider-table',
    templateUrl: './provider_table.component.html',
    styleUrls: ['./provider_table.component.scss'],
    imports: [MatProgressBar, FormsModule, ReactiveFormsModule, MatFormField, MatLabel, MatInput, MatButton, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIcon, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatNoDataRow, DatePipe]
})
export class ProviderTableComponent {
    currentPage = 1;
    moreServiceProvidersToLoad = false;
    loading = false;

    serviceProviders: ServiceProvider[] = [];
    serviceProviderDataSource = new MatTableDataSource<ServiceProvider>([]);

    serviceProviderColumnHeaders: string[] = [
        'name',
        'businessName',
        "stripeAccountId",
        'dateCreated',
        'primaryPhoneNumber',
        'secondaryPhoneNumber',
        'emailAddress',
        'address',
        'hasActiveServicePlan'
    ];

    searchFormGroup = new UntypedFormGroup({
        firstName: new UntypedFormControl(''),
        lastName: new UntypedFormControl(''),
        stripeAccountId: new UntypedFormControl('')
    })

    constructor(
        private serviceProviderService: ServiceProviderService,
        private tokenStorageService: TokenStorageService,
        private router: Router,
        public dialog: MatDialog,
    ) { }

    getAllProviders(): void {
        this.loading = true;
        const queryParams = new Map([
            ['firstName', this.searchFormGroup.controls['firstName'].value],
            ['lastName', this.searchFormGroup.controls['lastName'].value],
            ['stripeAccountId', this.searchFormGroup.controls['stripeAccountId'].value],
            ["pageNumber", this.currentPage.toString()],
        ]);

        this.serviceProviderService.getPaginatedProviders(['Paged'], queryParams).subscribe(result => {
            let paginationData: PaginationHeaderData = JSON.parse(result.headers.get('x-pagination'));
            this.moreServiceProvidersToLoad = paginationData.hasNext;
            this.serviceProviders = [...this.serviceProviders, ...result.body];
            console.log(this.serviceProviders)
            this.loading = false;
        }, () => { this.loading = false });
    }

    loadMoreProviders(): void {
        this.currentPage++;
        this.getAllProviders();
    }

    updateSearchParams(): void {
        this.serviceProviders = [];
        this.currentPage = 1;
        this.getAllProviders();
    }
}
